import { deleteCookie, getCookie } from '@/utils/cookies';
import { useEffect, useState } from 'react';
export default function useCookieConsent() {
    var _a = useState(null), consent = _a[0], setConsent = _a[1];
    var parseCookieYesString = function (cookieStr) {
        var entries = cookieStr.split(',').map(function (pair) { return pair.split(':'); });
        var result = {};
        entries.forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (key && value) {
                result[key.trim()] = value.trim();
            }
        });
        return result;
    };
    var removeFunctionalCookies = function () {
        ['movement', 'language'].forEach(function (cookieName) {
            deleteCookie(cookieName);
        });
    };
    var processConsent = function () {
        var cookie = getCookie('cookieyes-consent');
        if (!cookie) {
            applyConsentToAll();
            return;
        }
        try {
            var parsed = parseCookieYesString(cookie);
            if (parsed.functional === 'no')
                removeFunctionalCookies();
            setConsent(parsed);
        }
        catch (err) {
            // if failed to parse Cookie consent cookie just assume consent
            applyConsentToAll();
        }
    };
    useEffect(function () {
        processConsent();
        // Listen for user updates
        var handleUpdate = function () {
            processConsent();
        };
        document.addEventListener('cookieyes_consent_update', handleUpdate);
        return function () { return document.removeEventListener('cookieyes_consent_update', handleUpdate); };
    }, []);
    var hasConsented = function (category) {
        if (!consent)
            return false;
        return consent[category] === 'yes';
    };
    var applyConsentToAll = function () {
        setConsent({
            action: 'yes',
            advertisement: 'yes',
            analytics: 'yes',
            consent: 'yes',
            functional: 'yes',
            necessary: 'yes',
            other: 'yes',
            performance: 'yes',
        });
    };
    return { consent: consent, hasConsented: hasConsented };
}
